import PropTypes from 'prop-types';

/**
 * @deprecated
 * We no longer use enums for props (so that we don't force the user to import the enum).
 * This enum will remain here for backwards compatibility purposes.
 */
var TextTypes;
(function (TextTypes) {
    TextTypes["H1"] = "h1";
    TextTypes["H2"] = "h2";
    TextTypes["H3"] = "h3";
    TextTypes["H4"] = "h4";
    TextTypes["H5"] = "h5";
    TextTypes["H6"] = "h6";
    TextTypes["SUB1"] = "sub1";
    TextTypes["SUB2"] = "sub2";
    TextTypes["P"] = "p";
    TextTypes["BOLD"] = "bold";
    TextTypes["LABEL1"] = "label1";
    TextTypes["PRIMARYBTN"] = "primarybtn";
    TextTypes["TERTIARYBTN"] = "tertiarybtn";
    TextTypes["HYPERLINK"] = "hyperlink";
    TextTypes["NUMBER"] = "number";
    TextTypes["SUB3"] = "sub3";
    TextTypes["LABEL2"] = "label2";
    TextTypes["OVERLINE"] = "overline";
    TextTypes["LEGAL"] = "legal";
})(TextTypes || (TextTypes = {}));
var propTypes = {
    type: PropTypes.oneOf([
        TextTypes.H1,
        TextTypes.H2,
        TextTypes.H3,
        TextTypes.H4,
        TextTypes.H5,
        TextTypes.H6,
        TextTypes.SUB1,
        TextTypes.SUB2,
        TextTypes.P,
        TextTypes.BOLD,
        TextTypes.LABEL1,
        TextTypes.PRIMARYBTN,
        TextTypes.TERTIARYBTN,
        TextTypes.HYPERLINK,
        TextTypes.NUMBER,
        TextTypes.SUB3,
        TextTypes.LABEL2,
        TextTypes.OVERLINE,
        TextTypes.LEGAL,
    ]).isRequired,
    className: PropTypes.string,
    color: PropTypes.string,
    as: PropTypes.elementType,
};
var defaultProps = {
    type: TextTypes.P,
};

export { TextTypes, defaultProps, propTypes };
